// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","navBar":"App_navBar__1AtB5","middleContent":"App_middleContent__2Mx5u","footer":"App_footer__29Fsv"};